import fetcher from '../utils/api';

interface ListWritableDocumentsParams {
  searchQuery?: string;
  skip?: number;
  getFirst?: number;
}

const writableScribeDocumentService = {
  listWritableDocuments: async ({ searchQuery, skip, getFirst }: ListWritableDocumentsParams) => {
    const additionalParams = [];
    // name query

    if (searchQuery && searchQuery.trim().length > 1) {
      additionalParams.push(`q=${encodeURIComponent(searchQuery.trim())}`);
    }

    if (skip !== undefined && skip !== null) {
      additionalParams.push(`skip=${encodeURIComponent(skip)}`);
    }

    if (getFirst !== undefined && getFirst !== null) {
      additionalParams.push(`get_first=${encodeURIComponent(getFirst)}`);
    }
    return fetcher('scribe_documents/writable' + `${additionalParams.length > 0 ? '?' : ''}${additionalParams.join('&')}`, 'GET', true);
  }
};

export default writableScribeDocumentService;
